import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faClipboardList,
  faWallet,
  faBoxes,
  faTicket,
  faUser,
  faTrophy,
  faBars,
  faTimes,
  faSignOutAlt,
  faSun,
  faMoon,
} from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../ThemeContext';
import { useAuth } from '../AuthContext';
import './Sidebar.css';

const API = process.env.REACT_APP_API_URL || 'https://api.bustisha.com/api';
const BADGE_POLL = 3 * 60 * 1000;

const navItems = [
  { path: '/', label: 'New Order', icon: faBolt },
  { path: '/orders', label: 'Orders', icon: faClipboardList, badgeKey: 'failed_orders' },
  { path: '/add-fund', label: 'Add Fund', icon: faWallet },
  { path: '/services', label: 'Services', icon: faBoxes },
  { path: '/tickets', label: 'Tickets', icon: faTicket, badgeKey: 'unread_tickets' },
  { path: '/top-users', label: 'Top Users', icon: faTrophy },
  { path: '/profile', label: 'Profile', icon: faUser },
];

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [badges, setBadges] = useState({ unread_tickets: 0, failed_orders: 0 });
  const { theme, toggle } = useTheme();
  const { user, token, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    const fetchBadges = () => {
      fetch(`${API}/badges`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => r.json())
        .then((data) => setBadges({ unread_tickets: data.unread_tickets || 0, failed_orders: data.failed_orders || 0 }))
        .catch(() => {});
    };
    fetchBadges();
    const interval = setInterval(fetchBadges, BADGE_POLL);
    return () => clearInterval(interval);
  }, [token]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <>
      <button className="mobile-toggle" onClick={() => setOpen(!open)}>
        <FontAwesomeIcon icon={open ? faTimes : faBars} />
      </button>

      <div className={`sidebar-overlay ${open ? 'visible' : ''}`} onClick={() => setOpen(false)} />

      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <img src="/Black and Yellow Online Store Logo.png" alt="bustisha" className="logo-img" />
          <span className="logo-text">bustisha</span>
        </div>

        <div className="sidebar-balance">
          <span className="balance-label">Balance</span>
          <span className="balance-amount">TSHS {user?.balance ? Number(user.balance).toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'}</span>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const count = item.badgeKey ? badges[item.badgeKey] || 0 : 0;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `nav-item ${isActive ? 'active' : ''}`
                }
                onClick={() => setOpen(false)}
              >
                <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                <span className="nav-label">{item.label}</span>
                {count > 0 && <span className="nav-badge">{count > 99 ? '99+' : count}</span>}
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button className="theme-toggle" onClick={toggle}>
            <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
            <span>{theme === 'light' ? 'Dark' : 'Light'}</span>
          </button>
          <button className="logout-btn" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}
